<template>
  <div class="automation-group-modal">
    <TextInput
      :id="inputs.name.id"
      :label="inputs.name.label"
      v-model="inputs.name.binding"
      :error="inputs.name.error"
      :rules="inputs.name.rules"
      :placeholder="inputs.name.placeholder"
      @validate="onValidate('name', $event)"
    />

    <div class="modal__actions">
      <Btn variant="secondary" @click="handleCancel" type="button">Annuleren</Btn>
      <Btn variant="primary" @click="handleSubmit" type="button">
        {{ isEditing ? $t('automations_page.group_save') : $t('automations_page.group_add') }}
      </Btn>
    </div>
  </div>
</template>

<script>
  import { computed, watch, getCurrentInstance } from 'vue';
  import { useValidation } from '@/composables/useValidation';

  import TextInput from '@/components/inputs/TextInput.vue';
  import Btn from '@/components/partials/Btn.vue';

  export default {
    name: 'AutomationGroupModal',

    components: {
      TextInput,
      Btn,
    },

    emits: ['submit', 'cancel'],

    props: {
      group: {
        type: Object,
        default: () => null,
      },
    },

    setup(props, { emit }) {
      const instance = getCurrentInstance();
      const $t = instance.appContext.config.globalProperties.$t;
      const isEditing = computed(() => !!props.group);

      const { inputs, validateForm, onValidate } = useValidation({
        name: {
          id: 'automation_group_name',
          label: $t('automations_page.group_name'),
          binding: '',
          error: '',
          rules: ['required', 'maxLength:100'],
          placeholder: $t('automations_page.group_placeholder'),
        },
      });

      watch(
        () => props.group,
        (newGroup) => {
          inputs.value.name.binding = newGroup?.name || '';
        },
        { immediate: true }
      );

      const handleSubmit = async () => {
        const isValid = await validateForm();
        if (!isValid) return;
        emit('submit', { name: inputs.value.name.binding });
      };

      const handleCancel = () => emit('cancel');

      return {
        inputs,
        onValidate,
        isEditing,
        handleSubmit,
        handleCancel,
      };
    },
  };
</script>

<style scoped lang="scss">
  .automation-group-modal {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .modal__actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    padding-top: 1rem;
    border-top: 1px solid var(--slate-200);
  }
</style>
